import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onCloseFailedModal: () => void
  errorMessage: string | null | undefined
  nextCron: string
}

const FailedModal = ({ onCloseFailedModal, errorMessage, nextCron }: Props) => {
  return (
    <Modal
      illustration="alert"
      title={i18n.t('settings.edit_company.coffre_fort_numerique_form.card_title')}
      description={i18n.t('settings.edit_company.coffre_fort_numerique_form.modal.past_sync')}
      onClose={onCloseFailedModal}
    >
      <Box borderRadius={{ all: 'abs008' }} background="champagne400" paddingX="s24" paddingY="s16">
        <Text.Normal color="grey1000" size="300">
          {errorMessage}
        </Text.Normal>
      </Box>
      <Box paddingY="s24">
        <Text.Normal size="300">
          {i18n.t('settings.edit_company.coffre_fort_numerique_form.modal.future_sync', {
            nextCron: nextCron,
          })}
        </Text.Normal>
      </Box>
    </Modal>
  )
}

export default observer(FailedModal)
